import { FilterUtils } from '@elotech/components';
import { TransProgressKind, useTransProgress } from 'common/components';
import { isNumber } from 'common/utils';
import { axios } from 'libs';

import { downloadRawFile } from './ArquivoService';

const resource = '/documentos';
const defaultSort = {
  sort: 'id,asc'
};

export const findAllAutocomplete = (
  searchParam = '',
  pagination,
  sort = defaultSort
) => {
  const search = isNumber(searchParam)
    ? `id==${searchParam}`
    : FilterUtils.buildFilter(['descricao'])(searchParam);

  return axios.get(resource, {
    params: {
      search,
      ...pagination,
      ...sort
    }
  });
};

export const findAll = (search = '', pagination, sort = defaultSort) => {
  return axios.get(resource, {
    params: {
      search,
      ...pagination,
      ...sort
    }
  });
};

export const deleteById = id => {
  return axios.delete(`${resource}/${id}`);
};

export const findById = id => {
  return axios.get(`${resource}/${id}`);
};

export const save = documento => {
  return documento.id
    ? axios.put(`${resource}/${documento.id}`, documento)
    : axios.post(resource, documento);
};

export const downloadArquivo = (documentoId, nome) => {
  const progress = nome
    ? useTransProgress(nome, TransProgressKind.DOWNLOAD)
    : {};
  return axios
    .get(`${resource}/${documentoId}/download`, {
      ...progress,
      responseType: 'arraybuffer'
    })
    .then(({ data, headers }) => downloadRawFile(data, headers, nome, false));
};
